import Vue from "vue";
import VueClipboard from "vue-clipboard2";

import { loadJsonFromElement } from "../helpers/json";

import filters from "./modules/filters.vue";
import results from "./modules/results.vue";

import searchStore from "./stores/search"

Vue.use(VueClipboard);

new Vue({
    el: "#app",
    data: function () {
        return {
            filters: searchStore.state.filters,
            metaData: searchStore.state.metaData
        }
    },
    beforeMount: function () {
        searchStore.state.filters = Object.assign(this.filters, loadJsonFromElement("filters"));
        searchStore.state.metaData = Object.assign(this.metaData, loadJsonFromElement("metaData"));
    },
    components: {
        filters,
        results
    }
});